import script from "./IntroductionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntroductionItem.vue?vue&type=script&setup=true&lang=ts"

import "./IntroductionItem.vue?vue&type=style&index=0&id=a64d25d4&lang=scss"

const __exports__ = script;

export default __exports__